import React from 'react';

import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as l from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";

import * as ica from 'src/ica';

import * as _cv_41 from './_cv_41___Mz';

let $_41rs = [] as ht.ls;

import * as BtnTopC from './_ccmBtnTopC';
export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: pz.sPz.udt,
      bfrAsync: () => [
        _cv_41.load_41rLsAsync({
          cdn: pz.cz.cdn,
        })
        .then((_ls: ht.ls) => {
          $_41rs = _ls
        })
      ]
    });
  }, [
    pz.cz.cdn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [];
  const _cellCs = [
    {
      boxStlz: a('f/0.25'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '権限分類名'
          }
        })
      ]
    },
    {
      boxStlz: a('dw/10 f/n'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
  $_41rs?.map( ( _dz: ht.dz ) => {
    const _cellCs = [
      {
        boxStlz: a('f/0.25'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._icn,
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._pfx,
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {},
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  _41r_fst: _dz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/60'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};

